import { credoraRoutes } from "./CredoraRoutes";

export const routes = [...credoraRoutes];
